import { createSelector } from '@ngrx/store';

import map from 'lodash/map';
import flattenDepth from 'lodash/flattenDepth';
import { IDecoratorsCounters, NumberedCitation } from '../../models';
import { getCitation } from './get.citations';

export const getReferenceCount = createSelector(
  getCitation,
  ({ references, unnumbered_references }): IDecoratorsCounters => ({
    referencesCount: flattenDepth(
      map(references, (i: NumberedCitation) => i.referencedBy)
    ).length,
    unnumberedReferencesCount: unnumbered_references.length,
    keywordCount: 0,
  })
);
